import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { BillingExpiringSubscription } from './types';

export function useGetExpiringSubscriptions(days = 7) {
	return useQuery<BillingExpiringSubscription[]>({
		queryKey: ['billing-expiring-subscriptions', days],
		queryFn: async () => {
			const { data } = await api.get<BillingExpiringSubscription[]>(
				'/invoicing/expiring-subscriptions',
				{ params: { days } },
			);
			return data;
		},
	});
}
